import { useState, useEffect, useRef } from 'react';


const useForm = (callback, initialValues, validateMethods, initialTouchedState= undefined) => {
    const [ values, setValues ] = useState(initialValues || {});     // new state for errors
    const [ errors, setErrors ] = useState({});     // function that validates these errors
    const [ isSubmitting, setSubmitting ] = useState(false);
    const [ resetAdditionalErrorFields, setResetAdditionalErrorFields ] = useState(false);  // pass these errors back to form
    const [ touched, setTouched ] = useState(initialTouchedState  || {});

    const formRendered = useRef(true);

    useEffect(() => {
        if (formRendered.current) {
            setValues(initialValues);
            setErrors({});
        }
        formRendered.current = false;
    }, [initialValues]);

    //Don't remove the below commented section
    // function validate(enteredValues) {
    //     let errors = {};
    //     Object.entries(enteredValues).forEach(([name, value])=> {
    //         if(validateMethods[name] && validateMethods[name].length) {
    //             validateMethods[name].forEach(validateMethod => {
    //                 const data = validateMethod.validator(value)
    //                 if (data) {
    //                     errors[name] = errors[name] || [];
    //                     errors[name].push(validateMethod.useValidatorError ? data : validateMethod);
    //                 }
    //             });
    //         } else if (validateMethods[name] && validateMethods[name].validator(value)){
    //             errors[name] = errors[name] || [];
    //             errors[name].push(validateMethods[name]);
    //         }
    //     });
    //     return errors;
    // }
    function validate(enteredValues) {
        let errors = {};
        Object.entries(enteredValues).forEach(([name, value])=> {
            if(validateMethods[name] && validateMethods[name].length) {
                validateMethods[name].forEach(validateMethod => {
                    if(validateMethod.validator(value, values)){
                        errors[name] = errors[name] || [];
                        errors[name].push(validateMethod);
                    }
                });
            } else
            if(validateMethods[name] && validateMethods[name].validator(value, values)){
                errors[name] = errors[name] || [];
                errors[name].push(validateMethods[name]);
            }
        });
        setErrors(errors);
        return errors;
    }

    function handleChange(event, fieldArray = undefined, fieldArrayIndex = undefined){
        const { name, value } = event.target;
        const valuesCopy = JSON.parse(JSON.stringify(values));

        if (fieldArray && fieldArray.length) {
            const [field] = fieldArray;
            let fieldArrayObj = valuesCopy[field][fieldArrayIndex]; //
            fieldArrayObj[name] = value;
            valuesCopy[field][fieldArrayIndex] = fieldArrayObj;
            setValues(valuesCopy);
        } else {
            setValues(values =>({
                ...values,
                [name]: value
            }));
        }


    }

    function handleBlur(event, fieldArray = undefined, fieldArrayIndex = undefined){
        const { name, value } = event.target;
        const valuesCopy = JSON.parse(JSON.stringify(values));

        setTouched(prevTouched => ({ ...prevTouched, [name]: !!value }));

        if (fieldArray && fieldArray.length) {
            const [field] = fieldArray;
            let fieldArrayObj = valuesCopy[field][fieldArrayIndex]; //
            fieldArrayObj[name] = value;
            valuesCopy[field][fieldArrayIndex] = fieldArrayObj;
            setValues(valuesCopy);
        } else {
            setValues({
                ...values,
                [name]: value
            });
        }

        const newErrors = validate({
            [name]: value
        });
        delete errors[name];
        setErrors({
            ...errors,
            ...newErrors
        });

    }

    function handleFocus(event, fieldArray = undefined, fieldArrayIndex = undefined) {
        const { name } = event.target;

        if (fieldArray && fieldArray.length) {
            const valuesCopy = JSON.parse(JSON.stringify(values));
            const [field] = fieldArray;
            let fieldArrayObj = valuesCopy[field][fieldArrayIndex]; //
            valuesCopy[field][fieldArrayIndex] = fieldArrayObj;
            setValues(valuesCopy);
        } else {
            if(errors[name]) {
                setValues({
                    ...values,
                    [name]: ''
                });
            }
            delete errors[name];
            setErrors(errors);
        }
    }

    function resetFields(fields, additionalFields = undefined){
        if(fields && fields.length){
            let fieldsToReset = {};
            fields.forEach(field => {
                fieldsToReset[field] = '';
            });
            setValues({
                ...values,
                ...fieldsToReset
            });
            setErrors({});
            if(additionalFields && additionalFields.length) {
                let additionalFieldsToReset = {};
                additionalFields.forEach((additionalFields) => {
                    setResetAdditionalErrorFields(additionalFieldsToReset[additionalFields] = true); });
            }
        }
    }

    function resetErrors() {
        setErrors({});
    }


    function handleSubmit(event, specialValidationRequired = false, processedValues = undefined) {
        event.preventDefault();
        let valuesToValidate = {};
        const valuesToSubmit = processedValues || values;
        if(!specialValidationRequired) {
            valuesToValidate = valuesToSubmit;
        } else {
            Object.entries(valuesToSubmit).forEach(([key, value]) => {
                if(Array.isArray(value)) {
                    value.forEach((obj) => {
                        valuesToValidate[obj.fieldToValidateOnSubmit[0]] = obj[obj.fieldToValidateOnSubmit[0]];
                    });
                } else {
                    valuesToValidate[key] = value;
                }
            });
        }

        const newErrors = validate(valuesToValidate);
        setErrors(newErrors);
        setSubmitting(Object.keys(newErrors).length === 0);
        return newErrors;
    }

    useEffect(() => {
        // check to see if there are errors
        if(isSubmitting) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {
                setSubmitting(true);
            } else {
                setSubmitting(false);
            }
        }
    },[errors]);

    return {
        handleChange,
        handleBlur,
        handleSubmit,
        handleFocus,
        isSubmitting,
        values,
        errors,
        resetErrors,
        resetFields,
        resetAdditionalErrorFields,
        touched,
        validate
    };
};

export default useForm;